module.exports = __webpack_public_path__ + "static/media/ico-video-level3.74e709d4.svg";